import React from 'react'
import MaterialSymbol from '../material-symbol'

const Remove = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="remove" {...props} />
))

Remove.displayName = 'Remove'

export default Remove
